module.exports = __webpack_public_path__ + "media/images/muscleActionGray-e85477b0a854f3e71770ffc1cf72af90.svg";